import React from 'react';
import ContactUsForm from './contact-us-form';
import Image from 'next/image';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { faInstagramSquare } from '@fortawesome/free-brands-svg-icons';

const ContactUs = () => {
    return (
        <div className="pb-12 mx-4 md:mx-12 lg:mx-32 xl:mx-48 relative">
            <div className="md:flex">
                <div className="ImageContainer flex-grow">
                    <div className="md:hidden relative">
                        <span className="font-quas-stencil absolute bottom-12 right-8 text-white z-40 text-3xl">
                            AWAIT
                        </span>
                        <span className="absolute bottom-4 right-8 text-white z-40 text-xs text-right">
                            straightforward designs
                            <br /> of a sensible and calm nature
                        </span>
                        <Image
                            objectFit="cover"
                            layout="intrinsic"
                            width={400}
                            height={250}
                            className="image-gallery-image rounded-3xl animated fadeIn "
                            src="/images/contact-us/background-mobile.png"
                        />
                    </div>
                    <div className="hidden md:block lg:w-[600px] xl:w-[800px] text-center mx-auto">
                        <Image
                            objectFit="cover"
                            layout="intrinsic"
                            width={1200}
                            height={1000}
                            className="image-gallery-image rounded-3xl animated fadeIn "
                            src="/images/contact-us/background.png"
                        />
                    </div>
                </div>
                <div className="FormContainer xl:w-3/4 md:order-first md:mr-4">
                    <h2 className="About text-tan text-3xl md:text-6xl mb-4 font-kg-medium text-left mt-2">
                        CONNECT WITH REALM.
                    </h2>
                    <ContactUsForm />
                </div>

                <div className="Socials md:absolute md:bottom-[-20px] lg:bottom-[-20px] xl:bottom-[50px] text-white">
                    <h3>MNL/CEB</h3>
                    <a href="mailto:info@realmworkshop.co">
                        <span className="block">
                            <FontAwesomeIcon size="4x" icon={faEnvelope} className="text-xl mr-2" />
                            info@realmworkshop.co
                        </span>
                    </a>
                    <a href="https://www.instagram.com/realmworkshop">
                        <span>
                            <FontAwesomeIcon size="4x" icon={faInstagramSquare} className="text-xl mr-2" />
                            @realmworkshop
                        </span>
                    </a>
                </div>
            </div>
        </div>
    );
};

export default ContactUs;
